export const accountingUiSettings = {
  showFinancialStatementsInReportCentre: false
};
